import JSEncrypt from 'jsencrypt';

// tslint: disable-next-line: max-classes-per-file
class EncryptedBase
{
    private static PRIVATE_KEY: string;

    constructor(rsaKey: string)
    {
        EncryptedBase.PRIVATE_KEY = rsaKey;
    }

    protected encrypt(msg: string): any
    {
        const encryptor = new JSEncrypt({});

        encryptor.setPublicKey(EncryptedBase.PRIVATE_KEY);

        return encryptor.encrypt(msg);
    }
}

export class LoginEncrypted extends EncryptedBase
{
    public email: string;
    public password: string;
    public username: string;
    public code: string;
    public secretcode: string;

    constructor(email: string, password: string, username: string, code: string, rsaKey: string)
    {
        super(rsaKey);
        this.email = email;
        this.username = username;
        this.password = this.encrypt(password);
        this.code = code;
        this.secretcode = code;
    }

}